/**
 * @generated SignedSource<<5926d419147e9f0f479cbf7e913d5da9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type KlarnaOnSiteMessage_sku$data = {
  readonly displayPrice?: ReadonlyArray<{
    readonly convertedAmount: number | null;
  } | null> | null;
  readonly serviceId?: string | null;
  readonly " $fragmentType": "KlarnaOnSiteMessage_sku";
};
export type KlarnaOnSiteMessage_sku$key = {
  readonly " $data"?: KlarnaOnSiteMessage_sku$data;
  readonly " $fragmentSpreads": FragmentRefs<"KlarnaOnSiteMessage_sku">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "hasSkuId"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "isTrade"
    },
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "userCountryCode"
    },
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "KlarnaOnSiteMessage_sku",
  "selections": [
    {
      "condition": "hasSkuId",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "serviceId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "buyerId",
              "variableName": "userId"
            },
            {
              "kind": "Variable",
              "name": "isTrade",
              "variableName": "isTrade"
            },
            {
              "kind": "Variable",
              "name": "userCountryCode",
              "variableName": "userCountryCode"
            }
          ],
          "concreteType": "ItemDisplayPriceType",
          "kind": "LinkedField",
          "name": "displayPrice",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": [
                {
                  "kind": "Literal",
                  "name": "currency",
                  "value": "USD"
                }
              ],
              "kind": "ScalarField",
              "name": "convertedAmount",
              "storageKey": "convertedAmount(currency:\"USD\")"
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "ItemSkuType",
  "abstractKey": null
};

(node as any).hash = "b922e0e9e66b954269be70257b80c20a";

export default node;
